import {SETTINGS} from 'redux/actionTypes';

const initialState = {
	tools: false,
	mode: false,
	selection: {
		x1: false,
		x2: false,
		y1: false,
		y2: false
	}
};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case SETTINGS.RESET_MODE: {
			return {
				...state,
				mode: false
			};
		}
		case SETTINGS.CHANGE_MODE: {
			return {
				...state,
				mode: action.mode
			};
		}
		case SETTINGS.CHANGE_TOOLS: {
			return {
				...state,
				tools: action.tools
			};
		}
		case SETTINGS.SAVE_SELECTION: {
			return {
				...state,
				selection: action.selection
			};
		}
		default:
			return state;
	}
};

export default reducer;
